import { useFormContext } from 'react-hook-form'

import {
  ControlledNumberInput,
  FormError,
  FormField,
  FormItem,
  FormLabel,
} from '@fortem-monorepo/react-ui'

export interface UnitMultiplierFormFieldProps extends Omit<
  React.ComponentProps<typeof ControlledNumberInput>,
  'name'
> {}

export const UnitMultiplierFormField: React.FC<UnitMultiplierFormFieldProps> = ({ ...props }) => {
  const { control, register } = useFormContext<{ unit_multiplier: number }>()

  return (
    <FormField
      control={control}
      name="unit_multiplier"
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Unit Multiplier</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              {...register('unit_multiplier')}
              thousandSeparator={','}
              {...props}
            />
          </FormItem>
        )
      }}
    />
  )
}
